<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="130px"
              class="eidt-el-form"
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="是否人脸识别" prop="faceMatch">
              <el-switch v-model="ruleForm.faceMatch"></el-switch>
            </el-form-item>
            <el-form-item label="人脸识别阀值" prop="faceMatchScore">
              <el-input v-model="ruleForm.faceMatchScore"></el-input>
            </el-form-item>
            <el-form-item label="每天限制次数" prop="checkIn">
              <el-input
                  v-model="ruleForm.checkIn"
                  type="number"
                  min="1"
                  max="999"
              ></el-input>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                  v-model="ruleForm.price"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="使用开始时间" prop="startDate">
              <el-date-picker
                  v-model="ruleForm.startDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="使用结束时间" prop="endDate">
              <el-date-picker
                  v-model="ruleForm.endDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="使用有效时间" prop="effectiveDate">
              <el-date-picker
                  v-model="ruleForm.effectiveDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="有效时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="启用分论坛权限" prop="qrcodeSize">
              <el-select v-model="ruleForm.hit" placeholder="请选择">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件图片" prop="width">
              <UploadImg
                  @uploadImg="getUploadImg"
                  :editImg="editImg"
                  :imgTitle="imgTitle"
              ></UploadImg>
              <br/>
              <el-input
                  v-model="ruleForm.url"
              ></el-input>
            </el-form-item>
            <el-form-item label="证件宽(px)" prop="width">
              <el-input
                  v-model="ruleForm.width"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="证件高(px)" prop="height">
              <el-input
                  v-model="ruleForm.height"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码左编辑(px)" prop="qrcodeX">
              <el-input
                  v-model="ruleForm.qrcodeX"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码上边距(px)" prop="qrcodeY">
              <el-input
                  v-model="ruleForm.qrcodeY"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="二维码大小(px)" prop="qrcodeSize">
              <el-input
                  v-model="ruleForm.qrcodeSize"
                  type="number"
                  min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="规则" prop="rule">
              <el-input
                  v-model="ruleForm.rule"
                  :autosize="{ minRows: 4, maxRows: 1000 }"
                  type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="分享地址" prop="shareUrl">
              <el-input v-model="ruleForm.shareUrl" type="text" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px">分享图片</label>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg3"
                :editImg="editImg3"
                :imgTitle="imgTitle3"
            ></UploadImg>
            <el-form-item label="微信分享标题" prop="title">
              <el-input v-model="ruleForm.title" type="text"></el-input>
            </el-form-item>
            <el-form-item label="微信分享描述" prop="description">
              <el-input
                  v-model="ruleForm.description"
                  :autosize="{ minRows: 4, maxRows: 1000 }"
                  type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <label style="color: #f20; font-size: 16px"
              >微信分享图片:只能jpg格式</label
              >
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg4"
                :editImg="editImg4"
                :imgTitle="imgTitle4"
            ></UploadImg>
          </el-form>
          <div class="img-box">
            <el-image :src="editImg1"></el-image>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";

export default {
  name: "edittypemanage",
  data() {
    return {
      rules: {
        name: [
          {required: true, message: "请填写证件类型名称", trigger: "blur"},
        ],
        faceMatchScore: [
          {required: true, message: '请输入0-1之间的小数', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback();
              }
              if (value < 0 || value > 1) {
                callback(new Error('请输入0-1之间的小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        checkIn: [
          {required: true, message: "请填写限制次数", trigger: "blur"},
        ],
        // endDate: [
        //   {required: true, message: "结束日期不能为空", trigger: "blur"},
        // ],
        // startDate: [
        //   {required: true, message: "开始日期不能为空", trigger: "blur"},
        // ],
      },
      ruleForm: {
        faceMatch: false,
        faceMatchScore: 0,
        name: "",
        rule: "[\n" +
            "    {\n" +
            "        \"Index\": -1,\n" +
            "        \"Name\": \"\",\n" +
            "        \"Type\": \"\",\n" +
            "        \"BreakLine\": \"\",\n" +
            "        \"IsCenter\": \"True\",\n" +
            "        \"Font\": \"True\",\n" +
            "        \"FontFamily\": \"\",\n" +
            "        \"Color\": \"\",\n" +
            "        \"W\": 1063,\n" +
            "        \"H\": 1535,\n" +
            "        \"X\": 0,\n" +
            "        \"Y\": 0\n" +
            "    },\n" +
            "    {\n" +
            "        \"Index\": 1,\n" +
            "        \"Name\": \"code\",\n" +
            "        \"Type\": \"二维码\",\n" +
            "        \"BreakLine\": \"自动缩小\",\n" +
            "        \"IsCenter\": \"居中\",\n" +
            "        \"Font\": \"正常\",\n" +
            "        \"FontFamily\": \"思源黑体 CN 常规\",\n" +
            "        \"Color\": \"black\",\n" +
            "        \"W\": 165,\n" +
            "        \"H\": 165,\n" +
            "        \"X\": 450,\n" +
            "        \"Y\": 1200\n" +
            "    },\n" +
            "    {\n" +
            "        \"Index\": 2,\n" +
            "        \"Name\": \"code\",\n" +
            "        \"Type\": \"文字\",\n" +
            "        \"BreakLine\": \"自动缩小\",\n" +
            "        \"IsCenter\": \"居中\",\n" +
            "        \"Font\": \"正常\",\n" +
            "        \"FontFamily\": \"思源黑体 CN 常规\",\n" +
            "        \"Color\": \"black\",\n" +
            "        \"W\": 165,\n" +
            "        \"H\": 22,\n" +
            "        \"X\": 450,\n" +
            "        \"Y\": 1375\n" +
            "    },\n" +
            "    {\n" +
            "        \"Index\": 3,\n" +
            "        \"Name\": \"name\",\n" +
            "        \"Type\": \"文字\",\n" +
            "        \"BreakLine\": \"自动缩小\",\n" +
            "        \"IsCenter\": \"居中\",\n" +
            "        \"Font\": \"粗体\",\n" +
            "        \"FontFamily\": \"思源黑体 CN 常规\",\n" +
            "        \"Color\": \"black\",\n" +
            "        \"W\": 980,\n" +
            "        \"H\": 118,\n" +
            "        \"X\": 600,\n" +
            "        \"Y\": 940\n" +
            "    },\n" +
            "    {\n" +
            "        \"Index\": 4,\n" +
            "        \"Name\": \"company\",\n" +
            "        \"Type\": \"文字\",\n" +
            "        \"BreakLine\": \"自动缩小\",\n" +
            "        \"IsCenter\": \"居中\",\n" +
            "        \"Font\": \"粗体\",\n" +
            "        \"FontFamily\": \"思源黑体 CN 常规\",\n" +
            "        \"Color\": \"black\",\n" +
            "        \"W\": 980,\n" +
            "        \"H\": 58,\n" +
            "        \"X\": 373,\n" +
            "        \"Y\": 1108\n" +
            "    }]",
        url: "",
        width: "",
        height: "",
        qrcodeX: "",
        qrcodeY: "",
        qrcodeSize: "",
        startDate: "",
        endDate: "",
        effectiveDate: "",
        checkIn: 1,
        price: "",
        title: "",
        shareUrl: "",
        wechatUrl: "",
        description: "",
        img: "",
        hit: 0,
        projectId: localStorage.getItem("project_Id"),
      },
      editImg: "",
      editImg1: "",
      documentType_Id: "",
      dataList: [],
      imgTitle: "上传证件模板图片/电子证件图片",
      imgTitle3: "分享图片",
      imgTitle4: "微信分享图片",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    arrarList: {
      type: Array,
      default() {
        return [];
      },
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      const item = this.editData;
      this.ruleForm = item ? item : this.ruleForm;
      this.documentType_Id = item.documentTypeId;
      this.editImg = item.url;
      this.editImg3 = item.wechatUrl;
      this.editImg4 = item.img;
      this.editImg1 =
          localStorage.getItem("url") +
          "/DocumentType/Template/" +
          item.documentTypeId +
          "?t=" +
          new Date().toString();
    },
  },
  methods: {
    show() {
      this.editImg1 =
          localStorage.getItem("url") +
          "/DocumentType/Template/" +
          item.documentTypeId;
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.documentType_Id == "" || this.documentType_Id == undefined) {
            this.$axios.post("/DocumentType/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/DocumentType/" + this.documentType_Id + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.documentType_Id = "";
      this.editImg = "";
      this.editImg2 = "";
      this.editImg3 = "";
      this.editImg4 = "";
      this.$refs["ruleForm"].resetFields();
    },
    getUploadImg(imgSrc) {
      this.ruleForm.url = imgSrc;
    },
    getUploadImg2(imgSrc2) {
      this.editImg2 = imgSrc2;
      this.formData.banner = imgSrc2;
    },
    getUploadImg3(imgSrc3) {
      this.imgSrc3 = imgSrc3;
      this.formData.wechatUrl = imgSrc3;
    },
    getUploadImg4(imgSrc4) {
      this.imgSrc4 = imgSrc4;
      this.formData.img = imgSrc4;
    },
  },
  components: {
    UploadImg,
  },
};
</script>
<style lang="scss" scope>
.img-box {
  float: right;
  width: 400px;
  position: absolute;
  top: 80px;
  right: 0px;
}

img {
  width: 100%;
}

#qrcode {
  position: absolute;
}
</style>